import { render } from "./BaseRecipes.vue?vue&type=template&id=45f9bd74&scoped=true"
import script from "./BaseRecipes.vue?vue&type=script&lang=js"
export * from "./BaseRecipes.vue?vue&type=script&lang=js"

import "./BaseRecipes.vue?vue&type=style&index=0&id=45f9bd74&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f9bd74"]])

export default __exports__